

















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Tree as ElTree } from 'element-ui'
import { roleAuthByid, roleAuthByAppid, authorize } from '@/api/role'
import { InitModule } from '@/store/modules/init'
import { UserModule } from '@/store/modules/user'

interface AuthoritieProps {
  id: number
  name: string
}

// 权限列表根据平台id
interface AuthoritieListResponse {
  id: number
  name: string
  authorities: AuthoritieProps[]
}

// 角色列表根据账号id
interface RoleResponse {
  pid: number
  roleId: number
  name: string
}

// 树结构
interface NodeProps {
  id?: number
  label: string
  children?: NodeProps[]
}

@Component({
  name: 'AuthModal'
})
export default class extends Vue {
  @Prop({ default: false }) authDialogFlag!: boolean
  @Prop() id!: number
  @Prop() appId!: number
  private visible = false
  private loading = false
  private allNodeList: NodeProps[] = []
  private holdNodeList: number[] = []

  get appList() {
    return InitModule.appList
  }

  get adminId() {
    return UserModule.userInfo.adminId
  }

  // 初始化
  private async init() {
    this.loading = true
    const { content: all } = await roleAuthByAppid<AuthoritieListResponse[]>({ appId: this.appId }) // 所有的
    this.allNodeList = all.map(item => ({
      label: item.name,
      children: item.authorities.map(item => ({ label: item.name, id: item.id }))
    })).filter(item => item.children.length !== 0)
    const { content: hold } = await roleAuthByid<number[]>({ appid: this.appId, id: this.id,appId: this.appId, }) // 已拥有的
    // 回显
    this.holdNodeList = hold
    this.$nextTick(() => (this.$refs.tree as ElTree).setCheckedKeys(this.holdNodeList, true))
    this.loading = false
  }

  private close() {
    this.$emit('update:authDialogFlag', false)
  }

  private async onSubmit() {
    const authorities = (this.$refs.tree as ElTree).getCheckedKeys(true)
    await authorize({ authorities, id: this.id, appId: this.appId })
    this.$message.success('授权成功')
    this.close()
  }

  @Watch('authDialogFlag')
  async handQualityDialogFlag() {
    this.visible = this.authDialogFlag
    if (this.visible) {
      // 回填所持有权限
      if (this.id) {
        this.init()
      }
    }
  }
}
